export const mergePhotosPageTranslations = {
    ru: {
        title: "Объединение фото",
        description: "Объедините несколько фотографий в одну",
        photo1: "Фото 1",
        photo2: "Фото 2",
        uploadPhoto: "Загрузить фото",
        changePhoto: "Изменить фото",
        removePhoto: "Удалить фото",
        prompt: "Промпт",
        promptPlaceholder: "Введите описание того, как объединить фотографии...",
        promptDescription: "Опишите, как вы хотите объединить фотографии",
        merge: "Объединить",
        processing: "Обработка...",
        selectPhotos: "Выберите две фотографии для объединения",
        tabMerge: "Объединить",
        tabMyPhotos: "Мои объединенные фото",
        noPhotos: "У вас пока нет объединенных фотографий",
        loadingPhotos: "Загрузка фотографий...",
        createdAt: "Создано",
        download: "Скачать",
        delete: "Удалить",
    },
    en: {
        title: "Merge Photos",
        description: "Merge multiple photos into one",
        photo1: "Photo 1",
        photo2: "Photo 2",
        uploadPhoto: "Upload photo",
        changePhoto: "Change photo",
        removePhoto: "Remove photo",
        prompt: "Prompt",
        promptPlaceholder: "Enter a description of how to merge the photos...",
        promptDescription: "Describe how you want to merge the photos",
        merge: "Merge",
        processing: "Processing...",
        selectPhotos: "Select two photos to merge",
        tabMerge: "Merge",
        tabMyPhotos: "My Merged Photos",
        noPhotos: "You don't have any merged photos yet",
        loadingPhotos: "Loading photos...",
        createdAt: "Created",
        download: "Download",
        delete: "Delete",
    },
};
